const NUMBER_OF_RETRIES = 2;

export default class PdfPageBase {
  pdf = null;
  pageId = null;
  loadingTask = null;
  renderTask = null;

  lastRendered = null;

  DOMContainer = null;
  pdfPage = null;
  canvas = null;

  apiManager = null;

  cancelRender = false;

  pageNumber = null;

  options = null;

  _pdfRequestCounter = 0;
  _pdfRequestLimit = 10;

  constructor(appState, apiManager, DOMContainer, pageId, pageNumber, options) {
    this.pageId = pageId;
    this.DOMContainer = DOMContainer;
    this.apiManager = apiManager;
    this.appState = appState;
    this.pageNumber = pageNumber;
    this.options = options;
    this.pdfPage = this.DOMContainer.querySelector(".page-pdf");
    this.appState.on("appState:currentpagechanged", this.cleanup.bind(this));
    this.pdfPromise = null;
  }

  destroy() {
    this.pdf = null;
    this.renderTask = null;
    this.DOMContainer = null;
    this.pdfPage = null;
    this.canvas = null;
    this.pdfPromise = null;
    this.appState.off("appState:currentpagechanged", this.cleanup.bind(this));
  }

  cleanup() {}

  prefetchPDF() {
    if (!this.pdfPromise) {
      this.pdfPromise = this.retrievePdf();
    }
  }

  getPdfUrl() {
    if (this.appState.newDownloaderFallbackMode) {
      const { userId, sessionId, downloadId } = this.appState;
      return this.apiManager.retreivePdfUrl(
        this.pageId,
        sessionId,
        userId,
        downloadId
      );
    }
    return Promise.resolve(
      this.appState.cdnAssetsDownloader.getPdfUrl(this.pageId)
    );
  }

  retrievePdf(numberOfTries = 1) {
    if (this.pdf === null) {
      return this.getPdfUrl().then((url) => {
        return this.loadPdfJs(() => {
          const params = new Object();
          params.url = url;
          return PDFJS.getDocument(params)
            .then((pdf) => {
              return pdf.getPage(1).then((page) => {
                // altijd de eerste p van de pdf nemen en tonen
                this.pdf = page; //CASHING
                return Promise.resolve();
              });
            })
            .catch((error) => {
              if (error.status == 403) {
                if (numberOfTries < NUMBER_OF_RETRIES) {
                  return this.appState.cdnAssetsDownloader
                    .requestDownloadCredentials()
                    .then(() => {
                      return this.retrievePdf(numberOfTries + 1);
                    });
                } else {
                  this.appState.newDownloaderFallbackMode = true;
                  return this.retrievePdf(numberOfTries + 1);
                }
              }
              return Promise.reject(error);
            });
        });
      });
    }
    return Promise.resolve();
  }

  /**
   * Retreives the zoomscale that needs to be used for the pdf
   */
  getZoomScale() {
    const viewport = this.pdf.getViewport(1);
    const scaleX = this.DOMContainer.clientWidth / viewport.width;
    const scaleY = this.DOMContainer.clientHeight / viewport.height;
    const zoom = Math.min(scaleX, scaleY);
    return zoom;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/pdfPageBase.js